import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';

/* eslint-disable max-len */
/**
 * @name        AMP Trigger Video Utility
 * @file        amp-trigger-video-utility.js
 * @description
 */

/**
 * @class AmpTriggerVideoUtility
 */
class AmpTriggerVideoUtility {
  /**
   * constructor
   */
  constructor() {
    this.init();
  }

  /**
   * initialize the utility
   * @returns { void } none
   */
  init() {
    const triggerVideo = () => {
      if (URL.prototype) {
        // we don't want to run this on IE11
        const url = new URL(window.location.href);
        const videoID = url.searchParams.get('amp-video-id');
        const videoPlayButton = url.searchParams.get('amp-video-play-button');
        if (videoID && videoPlayButton) {
          document.getElementById(videoID).scrollIntoView();
          setTimeout(() => {
            document.getElementById(videoPlayButton).click();
          }, 1000); // find a better way to trigger video using cinema utility?
        }
      }
    };
    spartaEventsUtility.sub('SPARTA_GLOBAL_READY.spartaBootstrapUtility', triggerVideo);
  }
}
var index = new AmpTriggerVideoUtility();

export { index as default };
